import { z } from "zod";

export const InterviewEventTypeSchema = z.enum([
  "candidate_intention_start_interview",
  "interview_started",
  "candidate_intention_skip_intro_video",
  "candidate_intention_end_interview",
  "interview_ended",
]);

export type InterviewEventType = z.infer<typeof InterviewEventTypeSchema>;

export const InterviewEventPayloadSchema = z.object({
  callId: z.string().optional(),
  userId: z.string(),
  companyId: z.string(),
  eventType: InterviewEventTypeSchema,
  timestamp: z.number(),
});

export type InterviewEventPayload = z.infer<typeof InterviewEventPayloadSchema>;

// Validation utility function for client-side use
export function validateInterviewEventPayload(
  payload: unknown,
): InterviewEventPayload {
  return InterviewEventPayloadSchema.parse(payload);
}
